export enum ApiToolsUserEvents {
    GettingStartedClickNavLink = "API Tools - Getting Started - Click Nav Link",
    ApiKeysClickNavLink = "API Tools - API Keys - Click Nav Link",
    EndpointsClickNavLink = "API Tools - Endpoints - Click Nav Link",
    DocsClickNavLink = "API Tools - Docs - Click Nav Link",
    GettingStartedClickCreateApiKey = "API Tools - Getting Started - Click Create API Key",
    GettingStartedClickExploreEndpoints = "API Tools - Getting Started - Click Explore Endpoints",
    ClickDocumentationCTA = "API Tools - Click Documentation CTA",
}
